import './styles.scss';

const Filter = () => <div className="filter">Filter will be soon</div>;

export default Filter;
